var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"orange darken-2","size":"60","width":"10"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }